export default __webpack_public_path__ + "static/instagram-logo@2x-213c58178c10ef06c390bf26482d6576.png";